import React, { useCallback, useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "./FinancialDocumentStatusFilter.module.scss";

const SECTION_IMPORT = "Imported transactions";
const SECTION_RECONCILE = "Reconciled statement";
const SECTION_MATCH = "Matched receipt";

const OPTIONS: FilterMultiselectOption[] = [
    {
        value: "imported",
        label: "Imported",
        searchableLabel: "imported",
        section: SECTION_IMPORT,
    },
    {
        value: "importing",
        label: "Importing",
        searchableLabel: "importing",
        section: SECTION_IMPORT,
    },
    {
        value: "not_imported",
        label: "Not imported",
        searchableLabel: "not imported",
        section: SECTION_IMPORT,
    },
    {
        value: "reconciled",
        label: "Reconciled",
        searchableLabel: "reconciled",
        section: SECTION_RECONCILE,
    },
    {
        value: "reconciling",
        label: "Reconciling",
        searchableLabel: "reconciling",
        section: SECTION_RECONCILE,
    },
    {
        value: "not_reconciled",
        label: "Not reconciled",
        searchableLabel: "not reconciled",
        section: SECTION_RECONCILE,
    },
    {
        value: "matched",
        label: "Matched",
        searchableLabel: "matched",
        section: SECTION_MATCH,
    },
    {
        value: "not_matched",
        label: "Not matched",
        searchableLabel: "not matched",
        section: SECTION_MATCH,
    },
];

function filtersToValues(filters: BaseFilterProps["filters"]): string[] {
    const values: string[] = [];
    if (filters.isImported) {
        values.push("imported");
    }
    if (filters.isImporting) {
        values.push("importing");
    }
    if (filters.isNotImported) {
        values.push("not_imported");
    }
    if (filters.isDocReconciled) {
        values.push("reconciled");
    }
    if (filters.isDocReconciling) {
        values.push("reconciling");
    }
    if (filters.isDocNotReconciled) {
        values.push("not_reconciled");
    }
    if (filters.isDocMatched) {
        values.push("matched");
    }
    if (filters.isDocNotMatched) {
        values.push("not_matched");
    }
    return values;
}

export const FinancialDocumentStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = useMemo(() => filtersToValues(filters), [filters]);

    const handleChange = useCallback(
        (val: Array<string | number>) => {
            onChange({
                isImported: val.includes("imported") ? true : undefined,
                isImporting: val.includes("importing") ? true : undefined,
                isNotImported: val.includes("not_imported") ? true : undefined,
                isDocReconciled: val.includes("reconciled") ? true : undefined,
                isDocReconciling: val.includes("reconciling")
                    ? true
                    : undefined,
                isDocNotReconciled: val.includes("not_reconciled")
                    ? true
                    : undefined,
                isDocMatched: val.includes("matched") ? true : undefined,
                isDocNotMatched: val.includes("not_matched") ? true : undefined,
            });
        },
        [onChange],
    );

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                maxListHeight={340}
                inDropdown={false}
                searchable={false}
                options={OPTIONS}
                value={value}
                onChange={handleChange}
                name="documentStatus"
                onBlur={noop}
            />
        </div>
    );
};
